import { Components, Theme } from '@mui/material/styles';
import { palette } from 'theme/palette';

import inputCloseImage from 'assets/images/inputClose.svg?raw';
import { DEFAULT_BORDER_RADIUS } from '../constants';

export const MuiTextField: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        '& fieldset': {
          borderRadius: DEFAULT_BORDER_RADIUS,
        },
        '& .MuiInputBase-adornedStart': {
          padding: 0,
        },
        '& label.Mui-focused': {
          color: palette.grey[600],
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: palette.text.tertiary,
          },

          '&:hover fieldset': {
            borderColor: palette.text.secondary,
          },
          '&.Mui-focused fieldset': {
            borderColor: palette.grey[600],
          },
        },
        '& .MuiInputBase-input::-webkit-search-cancel-button': {
          appearance: 'none',
          height: theme.spacing(12),
          width: theme.spacing(12),
          backgroundImage: `url("data:image/svg+xml;base64, ${btoa(inputCloseImage)}")`,
          m: 0,
        },
      };
    },
  },
};
